import React, { useCallback, useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import BaseButton from '../../../Components/Buttons/BaseButton';
import SimpleDivider from '../../../Components/Dividers/SimpleDivider';
import CanceledIcon from '@material-ui/icons/RemoveCircleRounded';
import { BrillaFinancingLink } from '../../../Configs/Links';
import DebtPartialPaymentDialog from '../../Debts/DebtPartialPayment/DebtPartialPaymentDialog';
import { OpenNewTab } from '../../../Utils/Misc/Links';
import { GeneratePartialPaymentCouponAPI } from '../../../API/Debts/DebtsAPI';

const NoQuotaDetailGDC = props => {
  const { reasons, contractId } = props;

  // * OTHER HOOKS
  const classes = useStyles();
  const [
    openDebtPartialPaymentDialog,
    setOpenDebtPartialPaymentDialog
  ] = useState(false);

  const onClosePartialDebts = useCallback(() => {
    setOpenDebtPartialPaymentDialog(false);
  }, []);

  const renderReasons = () => {
    return (
      <>
        <SimpleDivider withoutMargin classes={classes.preReasonsDivider} />
        <Typography className={classes.reasonsTitle}>
          Razones por las cual no posee cupo brilla
        </Typography>
        <SimpleDivider withoutMargin classes={classes.reasonsDivider} />
        <>
          {reasons.map((reason, i) => (
            <div key={i}>
              <p className={classes.reason}>{reason}</p>
              {i < reasons.length - 1 && (
                <SimpleDivider classes={classes.internalReasonDivider} />
              )}
            </div>
          ))}
        </>
      </>
    );
  };
  // * FUNCTIONS
  return (
    <div className={classes.noQuotaDetailContainer}>
      {openDebtPartialPaymentDialog && (
        <DebtPartialPaymentDialog
          open={openDebtPartialPaymentDialog}
          onClose={onClosePartialDebts}
          requestCallback={GeneratePartialPaymentCouponAPI}
          paymentData={{ contractId }}
          description={
            <Typography className={classes.dialogDescription}>
              Ingresa el valor que deseas abonar. Recuerda que este cupón se
              aplicará a tu deuda que ya ha sido facturada del producto Brilla
              (servicios financieros).
            </Typography>
          }
        />
      )}
      <div>
        <Typography className={classes.noQuotaTitle}>
          <CanceledIcon className={classes.noQuotaIcon} /> Sin cupo disponible
        </Typography>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          className={classes.buttonContainerItem}
        >
          <Grid className={classes.buttonContainerItem}>
            <BaseButton
              fullWidth
              color="primary"
              variant="outlined"
              onClick={() => OpenNewTab(BrillaFinancingLink)}
            >
              ¿Dónde financiar?
            </BaseButton>
          </Grid>
          <Grid className={classes.buttonContainerItem}>
            <BaseButton
              fullWidth
              color="primary"
              variant="outlined"
              onClick={() => setOpenDebtPartialPaymentDialog(true)}
            >
              Abonar a deuda
            </BaseButton>
          </Grid>
        </Grid>
      </div>
      {renderReasons()}
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  reasonsTitle: {
    fontWeight: 500,
    fontSize: 13
  },
  preReasonsDivider: {
    marginBottom: '4.7%',
    marginTop: '4.7%'
  },
  reasonsDivider: {
    borderColor: 'rgb(185, 185, 185)'
  },
  reason: {
    fontSize: 11,
    textAlign: 'left',
    paddingLeft: 5,
    marginBottom: 12
  },
  internalReasonDivider: {
    marginTop: 0,
    marginBottom: theme.spacing(1)
  },
  noQuotaDetailContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  },
  noQuotaTitle: {
    fontSize: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  noQuotaIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.error.main
  },
  buttonContainerItem: {
    marginTop: theme.spacing(1),
    direction: 'row',
    flexGrow: 1,
    flexBasis: 190,
    gap: `${theme.spacing(2)}px`
  }
}));

export default NoQuotaDetailGDC;
